var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.458,28.492H24.542c-3.86,0-7,3.14-7,7v2.961v6.632v15.422c0,3.859,3.14,7,7,7h46.916c3.859,0,7-3.141,7-7V45.085 v-6.632v-2.961C78.458,31.632,75.317,28.492,71.458,28.492z M24.542,32.492h46.916c1.654,0,3,1.346,3,3v0.961H21.542v-0.961 C21.542,33.838,22.888,32.492,24.542,32.492z M74.458,43.085H21.542v-2.632h52.916V43.085z M71.458,63.508H24.542 c-1.654,0-3-1.346-3-3V47.085h52.916v13.422C74.458,62.162,73.112,63.508,71.458,63.508z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.13,50.404H25.951c-1.104,0-2,0.896-2,2s0.896,2,2,2H41.13c1.104,0,2-0.896,2-2S42.235,50.404,41.13,50.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.787,56.519h-8.836c-1.104,0-2,0.896-2,2s0.896,2,2,2h8.836c1.104,0,2-0.896,2-2S35.892,56.519,34.787,56.519z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.0abb8b970de1f4cab749bee433616546.svg";
export { ForwardRef as ReactComponent };